export default function scale({ x: cx, y: cy }, { x: tx, y: ty }, scale) {
  /**
   * scale center { x: cx, y: cy }
   * scale target point { x: tx, y: ty }
   */
  const nx = scale * (tx - cx) + cx;
  const ny = scale * (ty - cy) + cy;
  return { x: nx, y: ny };
}
